// In order to integrate OneTrust sdk we have use banner scripts

export const getOneTrustScript = (domainScriptId: string) => {
  // Onetrust test script with OptanonWrapper function which will be called after the script loads
  // External script must be loaded via dangerouslySetInnerHTML otherwise special characters will break
  // See https://codesandbox.io/s/remix-run-examples-google-analytics-9ioptr?file=/app/root.tsx

  // This code moves the accept-all button to the position with reject-all button
  // And hides the close button in regions where this is allowed

  // the "hide close button" part of the script below gets iso2CountryCode from html lang attribute formatted as "de-DE"
  // if the lang string is missing the country (i.e. lang="de" instead of "de-DE"),
  // this will default to use the EU settings showing the close button,
  // because we can't identify the country only from the language
  // for an example of how the html lang attribute is set,
  // check goldfish/packages/servers/src/registration/shared/components/RegistrationPage/index.js or goldfish/packages/servers/src/website/shared/components/WebsiteRoot/index.js

  return (
    <>
      <script
        defer
        src='https://cdn.cookielaw.org/scripttemplates/otSDKStub.js'
        data-document-language='true'
        type='text/javascript'
        data-domain-script={domainScriptId}
      />
      <script
        dangerouslySetInnerHTML={{
          __html: `function OptanonWrapper() {
      // reposition buttons
      const footerContainer = document.querySelector('.ot-pc-footer>.ot-btn-container')
      const acceptButton = document.getElementById('accept-recommended-btn-handler')
      if (footerContainer && acceptButton) {
        footerContainer.appendChild(acceptButton)
      }

      // hide close button
      const closeButton = document.querySelector('#onetrust-close-btn-container')
      const regionsToHideCloseButton = ['DE', 'AT', 'FR', 'ES']

      const region = document.documentElement.lang.length === 5 ? document.documentElement.lang.slice(-2).toUpperCase() : 'EU'
      const shouldHideCloseButton = regionsToHideCloseButton.includes(region)

      if (shouldHideCloseButton && closeButton) {
        closeButton.style.display = 'none'
      }
    }`,
        }}
      />
    </>
  )
}
